import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  resourceValue: {
    margin: 0,
    overflowWrap: 'anywhere',
    whiteSpace: 'pre-wrap'
  },
  submitButton: {
    marginTop: theme.spacing(1)
  },
  // The editor's mode line: "Editing X" or "Create X", with Cancel opposite.
  // Without it an operator who clicked Edit had no confirmation that the form
  // below now holds that row rather than a blank one.
  editorHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1)
  }
}))
